<template>
    <v-autocomplete
            v-model="model"
            :items="data"
            :label="label"
            :loading="loading"
            :search-input.sync="search"
            clearable
            chips
            deletable-chips
            item-value="id"
            item-text="name"
            color="primary"
            placeholder="Start typing to Search"
    />
</template>

<script>
    export default {
        name: "choose-beesline-area-cluster",
        props: ['label', 'value'],
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        mounted() {
            this.loading = true;
            const params = new URLSearchParams();
            params.append('perPage', "50");
            this.axios.get(this.api.ACTIONS.BEESLINE_AREA_CLUSTER, {params})
                .then(res => {
                    const {data: {data}} = res.data;
                    this.data = data;
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            model(val) {
                this.$emit("input", val);
            }
        }
    }
</script>

<style scoped>

</style>